/**
 * http://detectmobilebrowsers.com/
 * @type {{check: DetectMobileBrowsers.check}}
 */
const DetectMobileBrowsers = {
  check: function() {
    return $("body").hasClass("mobile");
  }
};

export default DetectMobileBrowsers;
